<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive" />
    <tab-bar
      v-if="this.$route.meta.showTab"
      :active="this.$route.meta.tabbarActive"
    ></tab-bar>
  </div>
</template>

<script>
import TabBar from "components/content/tabbar/TabBar";
export default {
  name: "App",
  components: {
    TabBar,
  },
};
</script>

<style>
@import "assets/css/base.css";
</style>
